import { render, staticRenderFns } from "./DeliveryNotesTable.vue?vue&type=template&id=a4d82548&scoped=true&"
import script from "./DeliveryNotesTable.vue?vue&type=script&lang=js&"
export * from "./DeliveryNotesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d82548",
  null
  
)

export default component.exports